//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('selectArticles', {
//        templateUrl: 'views/components/views/selectArticles/selectArticles.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'selectArticlesService', 'ttGridFactory', 'rememberService', function (stateService, utilityService, selectArticlesService, ttGridFactory, rememberService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            let variableNames = {
//                searchtext: ''
//            };

//            vm.model = {
//                gridReady: false,
//                searchTextButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('searchtext') },
//                    { id: 'search', icon: 'fas fa-search', color: 'primary', type: 'primary', onClick: () => vm.retrieveChanges() }
//                ],
//                setting: {}
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: '',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setToolbar({ wrapping: true });

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await selectArticlesService.getSelectArticles())[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                if (utilityService.validateParmsValue(vm.model.setting.view_id) === true) {
//                    vm.grid.dataTask.rememberId = vm.model.setting.view_id;
//                }

//                if (utilityService.validateParmsValue(vm.model.setting.p2_datatask_keyno) === true
//                    && utilityService.validateParmsValue(vm.model.setting.searchtext, true) === true
//                    && utilityService.validateParmsValue(vm.model.setting.retrieve_only_selected) === true) {
//                    vm.grid.dataTask.loadData = {
//                        method: vm.model.setting.p2_datatask_keyno,
//                        parameters: vm.model.setting
//                    };
//                }

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'searchtext':
//                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region MULTI CLEAR FUNCTION

//            async function clear(id) {
//                switch (id) {
//                    case 'searchtext':
//                        vm.model.setting.searchtext = '';

//                        if (vm.model.setting.searchtext === '') {
//                            rememberFunc('searchtext');
//                            await loadGrid();
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion MULTI CLEAR FUNCTION

//            // #region BUTTON RETRIEVE FUNCTION CALL

//            vm.retrieveChanges = async function () {
//		        rememberFunc('searchtext');
//                await loadGrid();
//            }

//            // #endregion BUTTON RETRIEVE FUNCTION CALL

//            // #region ON BLUR MULTI FUNCTIONS

//            vm.onBlur = function (id) {
//                switch (id) {
//                    case 'searchtext':
//                        if (utilityService.validateParmsValue(vm.model.setting.searchtext, true) !== true) return;

//                        rememberFunc('searchtext');
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion ON BLUR MULTI FUNCTIONS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = async function (value, id) {
//                switch (id) {
//                    case 'searchtext':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.searchtext) !== true) return;

//                        vm.model.setting.searchtext = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.searchtext, true) !== true) return;

//                        if (vm.model.setting.searchtext === '') {
//                            rememberFunc('searchtext');
//                            await loadGrid();
//                        }
//                        break;
//                    case 'retrieve_only_selected':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.retrieve_only_selected) !== true) return;

//                        vm.model.setting.retrieve_only_selected = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.retrieve_only_selected) !== true) return;

//                        loadGrid();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadGrid();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
